// extracted by mini-css-extract-plugin
export default {"headerGlobal":"Global_headerGlobal__KtXQ+","headerRelatorios":"Global_headerRelatorios__3wa2R"};